export default __webpack_public_path__ + "static/media/jobllegro_background_subpage.de610126.jpg";